// Steps the login page can render
export type LoginStep = 'credentials' | 'code' | 'setup'

// What the login response says to do next — 'done' means finish the login now
export type LoginNextStep = 'done' | 'code' | 'setup'

export interface LoginResponse {
  status?: boolean
  msg?: string
  access_token?: string
  two_factor_required?: boolean
  two_factor_setup_required?: boolean
  method?: string
  challenge_id?: string
  email_hint?: string
  expires_in?: number
  setup_token?: string
  email?: string
  data?: { user_type?: string }
}

export const nextStepFromLoginResponse = (
  resp: LoginResponse | null | undefined
): LoginNextStep => {
  if (resp?.two_factor_required) return 'code'
  if (resp?.two_factor_setup_required) return 'setup'
  return 'done'
}

const errorMessage = (err: any) =>
  typeof err?.response?.data?.msg === 'string'
    ? err.response.data.msg
    : typeof err?.msg === 'string'
      ? err.msg
      : ''

export const isSessionExpired = (err: any) =>
  /session has expired|sign in again/i.test(errorMessage(err))

export const isCodeMismatch = (err: any) => /invalid verification code/i.test(errorMessage(err))

// "JBSWY3DPEHPK3PXP" -> "JBSW Y3DP EHPK 3PXP" so the manual key can be read out loud
export const formatSecret = (secret: string) =>
  (secret || '')
    .replace(/\s+/g, '')
    .replace(/(.{4})/g, '$1 ')
    .trim()
